import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
  MAT_DIALOG_DATA
} from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { finalize, Subject, switchMap, takeUntil } from 'rxjs';
import { DialogAddOpIncidentComponent } from 'src/app/incidencias/dialog-add-op-incident/dialog-add-op-incident.component';
import { Pax } from 'src/app/model/file/model.file';
import { FileService } from 'src/app/services/api/file.service';
import { FunctionsService } from 'src/app/services/api/functions.service';
import { IncidentService } from 'src/app/services/api/incident.service';
import Swal from 'sweetalert2';
import { BIBLIA_ACTIONS } from '../biblia.actions';

@Component({
  selector: 'app-dialog-servicios-list',
  templateUrl: './dialog-servicios-list.component.html',
  styleUrls: ['./dialog-servicios-list.component.css']
})
export class DialogServiciosListComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  private destroy$ = new Subject<void>();

  columnsTable: string[] = [
    'nombreServicio',
    'tipoServicio',
    'proveedorServicio',
    'acciones'
  ];

  columnsTipoDeUnidad: string[] = [
    'nombreServicio',
    'proveedor',
    'tipoServicio',
    'acciones'
  ];

  columnsRestriccionTable: string[] = ['nombrePax', 'apellidoPax', 'acciones'];

  opIncidentTableSource = new MatTableDataSource<any>();
  opIncidentColumns: string[] = [
    'createdAt', // Fecha de creación
    'serviceName', // Nombre del servicio al que se le asignó la incidencia
    'serviceType', // Tipo del servicio al que se le asignó la incidencia
    'description', // Descripción de la incidencia
    'reportedBy', // Usuario que reportó la incidencia
    'opIncidentType', // Tipo de incidencias op
    'incidentStatus', // Estado CREATED, IN_PROGRESS, FINISHED
    'solutionDate', // Fecha de resolución dd-MM-YYYY
    'solutionTime', // Tiempo de solución en horas / días
    'actions' // Acciones realizadas para arreglar
  ];

  isLoading: boolean = true;
  type: string | null = null;
  dataServiceToUpdated: any = null;
  arrayServices: string[] = [];
  arrayProviders: string[] = [];
  arrayTypesServices: string[] = [];
  serviceSelected: string | null = null;
  providerSelected: string | null = null;
  typeServiceSelected: string | null = null;

  dataServices = new MatTableDataSource<any>();

  dataActivity = new MatTableDataSource<any>();
  columnsActivity: string[] = ['dayName', 'agencia', 'fileNumber', 'acciones'];

  dataTipoDeUnidad = new MatTableDataSource<any>();
  saving: boolean = false;
  infoService: any = {};

  tablaType: string = 'incidenciaService';
  tablaTypeObs: string = 'obsService';
  fileIncidencias: any[] = [];

  activeTextArea: number = -1;

  observaciones: string = '';
  tipoDeUnidad: string = '';
  restricciones: string = '';
  newCondition: string = '';
  newAllergy: string = '';

  isIncidenciasPorServicio = false;
  isIncidenciasPorFile = false;

  isObsPorServicio = false;
  isObsPorActividad = false;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  @ViewChild(MatPaginator) paginator2!: MatPaginator;
  @ViewChild(MatSort) sort2!: MatSort;

  constructor(
    public dialogRef: MatDialogRef<DialogServiciosListComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      type: string;
      activity: any;
    },
    private readonly incidentService: IncidentService,
    private readonly fileService: FileService,
    public functionService: FunctionsService,
    public dialog: MatDialog,
    private cdRef: ChangeDetectorRef // Inyecta ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    console.log({
      isLoading: this.isLoading
    });
    this.type = this.data.type;

    if (this.type == BIBLIA_ACTIONS.RESTRICCIONES) {
      this.loadRestricciones();
    } else if (this.type == BIBLIA_ACTIONS.CONDICIONESMEDICAS) {
      this.loadCondicionesMedicas();
    } else if (this.type == BIBLIA_ACTIONS.ALERGIAS) {
      this.loadAlergias();
    } else if (this.type == BIBLIA_ACTIONS.INCIDENCIAS) {
      console.log({
        INCIDENCIAS_DIALOG: this.data
      });
      this.fetchOpIncidents();
    } else if (this.type == BIBLIA_ACTIONS.TIPODEUNIDAD) {
      this.loadTipoDeUnidad();
      console.log('entro');
    } else {
      this.loadServices();
    }
    this.arrayServices = this.data.activity.lstServicios.map(
      (item: any) => item.nombreServicio
    );
    this.arrayProviders = this.data.activity.lstServicios.map(
      (item: any) => item.objProvider.nombre
    );
    this.arrayTypesServices = this.data.activity.lstServicios.map(
      (item: any) => item.tipoServicio
    );
  }

  ngAfterViewInit(): void {
    if (this.tablaType == 'file') {
      this.opIncidentTableSource.paginator = this.paginator2;
      this.opIncidentTableSource.sort = this.sort2;
    } else if (this.tablaTypeObs == 'obsService') {
      this.dataServices.paginator = this.paginator2;
      this.dataServices.sort = this.sort2;
    } else if (this.tablaTypeObs == 'obsActivity') {
      this.dataActivity.paginator = this.paginator2;
      this.dataActivity.sort = this.sort2;
    } else {
      this.dataServices.paginator = this.paginator;
      this.dataServices.sort = this.sort;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  toggleSwitch(type: 'servicio' | 'file') {
    if (type === 'servicio') {
      this.isIncidenciasPorServicio = true;
      this.isIncidenciasPorFile = false;
      this.changeTablaType('servicio');
    } else if (type === 'file') {
      this.isIncidenciasPorServicio = false;
      this.isIncidenciasPorFile = true;
      this.changeTablaType('file');
    }
  }

  toggleSwitchObs(type: 'obsService' | 'obsActivity') {
    if (type === 'obsService') {
      this.isObsPorServicio = true;
      this.isObsPorActividad = false;
      this.changeTablaTypeObs('obsService');
    } else if (type === 'obsActivity') {
      this.isObsPorServicio = false;
      this.isObsPorActividad = true;
      this.changeTablaTypeObs('obsActivity');
    }
  }

  close() {
    this.dialogRef.close();
  }

  fetchOpIncidents() {
    this.isLoading = true;
    console.log({
      fetchOpIncidents_isLoading: this.isLoading
    });

    this.incidentService
      .findOpIncidentsByItineraryId({
        itineraryId: this.data.activity.idItinerary
      })
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this.cdRef.detectChanges();
        }),
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: (res: any) => {
          console.log({ res });
          if (res.findOpIncidentsByItineraryId) {
            const mappedOpIncidentRows = res.findOpIncidentsByItineraryId?.map(
              (opIncident: any) => {
                const matchedService = this.data.activity.lstServicios.find(
                  (service: any) => service.id === opIncident.serviceId
                );
                return {
                  ...opIncident,
                  serviceName: matchedService?.nombreServicio || '-',
                  serviceType: matchedService?.tipoServicio || '-'
                };
              }
            );

            console.log({ mappedOpIncidentRows });
            this.opIncidentTableSource.data = mappedOpIncidentRows || [];
            this.opIncidentTableSource.paginator = this.paginator2;
            this.opIncidentTableSource.sort = this.sort2;
          }
        },
        error: (err) => {
          console.error('Error fetching operational incidents', err);
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: 'Error al cargar las incidencias operativas',
            showConfirmButton: true
          });
        }
      });
  }

  openDialogAddOpIncident() {
    const availableServices = this.data.activity.lstServicios || [];
    console.log({
      availableServices
    });

    if (!this.isLoading) {
      const dialogConfig = new MatDialogConfig();

      dialogConfig.data = {
        itineraryId: this.data.activity.idItinerary,
        availableServices,
        associatedServiceIds: this.data.activity.lstServicios
          .filter((aService: any) =>
            this.opIncidentTableSource.data.some(
              (opIncident: any) => opIncident.serviceId === aService.id
            )
          )
          .map((service: any) => service.id),
        fileNumber: this.data?.activity?.fileNumber,
        activityDayNumber: this.data?.activity?.day,
        activityDayName: this.data?.activity?.dayName,
        associatedService: undefined
      };

      dialogConfig.width = '80%';
      dialogConfig.maxHeight = '750px';
      dialogConfig.maxWidth = '700px';

      const dialogRef = this.dialog.open(
        DialogAddOpIncidentComponent,
        dialogConfig
      );

      dialogRef.afterClosed().subscribe((result) => {
        if (!result || result?.event === 'nothing') return;
        if (result.event === 'op_incident_create') {
          this.opIncidentTableSource.data = [
            ...this.opIncidentTableSource.data,
            result.op_incident_create
          ].sort(
            (a, b) =>
              new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
          );
        }
      });
    }
  }

  renameOpIncidentStatus(status: string) {
    switch (status) {
      case 'CREATED':
        return 'Creado';
      case 'IN_PROGRESS':
        return 'En Proceso';
      case 'FINISHED':
        return 'Solucionado';
      default:
        return status;
    }
  }

  loadDataAndFilter(field: string) {
    this.isLoading = true;

    const sourceList =
      this.data.activity.lstPaXByActivity ||
      this.data.activity.itineraryLstPaX ||
      [];

    // Filter by estado === true
    const activePax = sourceList.filter((p: any) => p.estado === true);

    const passengerFields: any = {
      id: true,
      firstName: true,
      lastName: true
    };
    passengerFields[field] = true;

    this.fileService
      .getAssignedPassengers({
        itineraryId: this.data.activity.idItinerary || '',
        passengerFields
      })
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe({
        next: (res: any) => {
          const freshPassengers = res.getAssignedPassengers || [];

          const displayList = activePax.map((item: any) => {
            const freshPax = freshPassengers.find(
              (p: any) => p.id === item.passengerId
            );
            if (freshPax) {
              return {
                ...item,
                pasajero: {
                  ...(item.pasajero || {}),
                  ...freshPax
                }
              };
            }
            return item;
          });

          this.dataServices = new MatTableDataSource(displayList);
        },
        error: (err) => {
          console.error('Error loading passengers', err);
        }
      });
  }

  loadRestricciones() {
    this.loadDataAndFilter('restriccionesAlimentarias');
  }
  loadCondicionesMedicas() {
    this.loadDataAndFilter('condicionesMedicas');
  }
  loadAlergias() {
    this.loadDataAndFilter('alergias');
  }
  loadServices() {
    this.dataServices = new MatTableDataSource(this.data.activity.lstServicios);
    this.dataActivity = new MatTableDataSource([this.data.activity]);
    console.log(this.dataActivity);
    this.isLoading = false;
  }

  loadTipoDeUnidad() {
    console.log(this.data.activity);
    this.dataTipoDeUnidad = new MatTableDataSource(
      this.data.activity.serviciosTransporte
    );
    console.log(this.dataTipoDeUnidad);
    this.isLoading = false;
  }

  updateObservacionToService(row_obj: any) {
    console.log(row_obj);
    this.activeTextArea = -1;

    if (row_obj.observaciones !== this.observaciones) {
      let observacionesFromService: any = null;

      // Buscar y actualizar observación del servicio
      this.data.activity.lstServicios.forEach((value: any) => {
        if (value.id === row_obj.id) {
          value.observaciones = this.observaciones;
          observacionesFromService = value;
        }
      });

      this.fileService
        .getItineraryServiceById(row_obj.id)
        .pipe(
          switchMap((dataDetailsFiles: any) => {
            const dataServiceToUpdated =
              dataDetailsFiles.getItineraryServiceById;

            const serviceUpdated = {
              ...dataServiceToUpdated,
              observaciones: observacionesFromService.observaciones
            };

            return this.fileService.updateServiceItinerary(serviceUpdated);
          })
        )
        .subscribe({
          next: (result) => {
            console.log('respuesta', result);
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Se editó la observación',
              showConfirmButton: false,
              timer: 4000
            });
            this.ngOnInit();
          },
          error: (error) => {
            console.error(error);
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: 'Ocurrió un error al guardar',
              showConfirmButton: false,
              timer: 4000
            });
          }
        });
    }
  }
  updateObservacionToActivity(row_obj: any) {
    console.log('row_obj', row_obj);
    this.activeTextArea = -1;

    if (row_obj.obsActivity !== this.observaciones) {
      // Actualizar observación localmente
      this.data.activity.obsActivity = this.observaciones;
      console.log('row_obj', row_obj.idActivity);
      console.log('this.data', this.data);

      this.fileService
        .updateObservacionesActivity(
          row_obj.idActivity,
          this.observaciones,
          'NORMAL'
        )
        .subscribe({
          next: (data) => console.log('respuesta actividad', data),
          complete: () => {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Proceso Exitoso',
              showConfirmButton: false,
              timer: 5000
            });
            this.ngOnInit();
          },
          error: () => {
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: 'Ocurrió un error',
              showConfirmButton: false,
              timer: 5000
            });
          }
        });
    }
  }

  addTipoDeUniadToService(row_obj: any) {
    this.activeTextArea = -1;

    const parsedTipoDeUnidad = this.parseTipoDeUnidadInput(this.tipoDeUnidad);

    if (
      this.formatTipoDeUnidad(row_obj.tipoDeUnidad) !==
      this.formatTipoDeUnidad(parsedTipoDeUnidad)
    ) {
      let tipoDeUnidadFromService: any = null;

      // Buscar y actualizar observación del servicio
      this.data.activity.serviciosTransporte.forEach((value: any) => {
        if (value.id === row_obj.id) {
          value.tipoDeUnidad = parsedTipoDeUnidad;
          tipoDeUnidadFromService = value;
        }
      });
      console.log(row_obj.id);
      this.fileService
        .getItineraryServiceById(row_obj.id)
        .pipe(
          switchMap((dataDetailsFiles: any) => {
            const dataServiceToUpdated =
              dataDetailsFiles.getItineraryServiceById;

            const serviceUpdated = {
              ...dataServiceToUpdated,
              tipoDeUnidad: tipoDeUnidadFromService.tipoDeUnidad,
              editOperation: true
            };

            return this.fileService.updateServiceItinerary(serviceUpdated);
          })
        )
        .subscribe({
          next: (result) => {
            console.log('respuesta', result);
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Se editó la observación',
              showConfirmButton: false,
              timer: 4000
            });
            this.ngOnInit();
          },
          error: (error) => {
            console.error(error);
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: 'Ocurrió un error al guardar',
              showConfirmButton: false,
              timer: 4000
            });
          }
        });
    }
  }

  updateRestriccionAlimentariaToPaxItineraryActivities(paxToEdit: any) {
    this.activeTextArea = -1;

    if (
      typeof this.restricciones !== 'string' ||
      this.restricciones.trim() === ''
    ) {
      Swal.fire({
        position: 'top-end',
        icon: 'warning',
        title: 'La restricción alimentaria no puede estar vacía.',
        showConfirmButton: false,
        timer: 4000
      });
      return;
    }

    if (paxToEdit.pasajero.restriccionesAlimentarias !== this.restricciones) {
      Swal.fire({
        position: 'top-end',
        icon: 'info',
        title: 'Actualizando la restricción alimentaria...',
        showConfirmButton: false
      });

      this.fileService
        .mutationUpdatePassengerField({
          passengerId: paxToEdit.passengerId,
          field: 'restriccionesAlimentarias',
          value: this.restricciones
        })
        .pipe(
          finalize(() => {
            this.isLoading = false;
          })
        )
        .subscribe({
          next: (dataDetailsFiles: any) => {
            if (dataDetailsFiles?.updatePassengerField) {
              Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'Se editó la restricción',
                showConfirmButton: false,
                timer: 4000
              });
              this.data.activity.lstPaXByActivity =
                this.data.activity.lstPaXByActivity.map((pax: any) => {
                  if (pax.passengerId === paxToEdit.passengerId) {
                    return {
                      ...pax,
                      pasajero: {
                        ...pax.pasajero,
                        restriccionesAlimentarias: this.restricciones
                      }
                    };
                  }
                  return pax;
                });
              this.ngOnInit();
            } else {
              Swal.fire({
                position: 'top-end',
                icon: 'warning',
                title: 'No se pudo actualizar la restricción',
                showConfirmButton: false,
                timer: 4000
              });
            }
          },
          error: (err) => {
            console.error('Error al actualizar el pasajero:', err);
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: 'Ocurrió un error al actualizar la restricción',
              showConfirmButton: true
            });
          }
        });
    }
  }
  updateCondicionMedicaToPaxToItinerary(paxToEdit: any) {
    this.activeTextArea = -1;

    if (
      typeof this.newCondition !== 'string' ||
      this.newCondition.trim() === ''
    ) {
      Swal.fire({
        position: 'top-end',
        icon: 'warning',
        title: 'La condición médica no puede estar vacía.',
        showConfirmButton: false,
        timer: 4000
      });
      return;
    }

    if (paxToEdit.pasajero.condicionesMedicas !== this.newCondition) {
      Swal.fire({
        position: 'top-end',
        icon: 'info',
        title: 'Actualizando la condición médica del pasajero...',
        showConfirmButton: false
      });

      this.fileService
        .mutationUpdatePassengerField({
          passengerId: paxToEdit.passengerId,
          field: 'condicionesMedicas',
          value: this.newCondition
        })
        .pipe(
          finalize(() => {
            this.isLoading = false;
          })
        )
        .subscribe({
          next: (dataDetailsFiles: any) => {
            if (dataDetailsFiles?.updatePassengerField) {
              Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'Se editó la condición médica del pasajero',
                showConfirmButton: false,
                timer: 4000
              });
              this.data.activity.lstPaXByActivity =
                this.data.activity.lstPaXByActivity.map((pax: any) => {
                  if (pax.passengerId === paxToEdit.passengerId) {
                    return {
                      ...pax,
                      pasajero: {
                        ...pax.pasajero,
                        condicionesMedicas: this.newCondition
                      }
                    };
                  }
                  return pax;
                });
              this.ngOnInit();
            } else {
              Swal.fire({
                position: 'top-end',
                icon: 'warning',
                title: 'No se pudo actualizar la condición médica',
                showConfirmButton: false,
                timer: 4000
              });
            }
          },
          error: (err) => {
            console.error('Error al actualizar el pasajero:', err);
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: 'Ocurrió un error al actualizar la condición médica',
              showConfirmButton: true
            });
          }
        });
    }
  }

  updateAllergyToItineraryActivities(paxToEdit: any) {
    this.activeTextArea = -1;

    if (typeof this.newAllergy !== 'string' || this.newAllergy.trim() === '') {
      Swal.fire({
        position: 'top-end',
        icon: 'warning',
        title: 'La alergia no puede estar vacía.',
        showConfirmButton: false,
        timer: 4000
      });
      return;
    }

    if (paxToEdit.pasajero.alergias !== this.newAllergy) {
      console.log({
        paxToEdit,
        lstPaXByActivity: this.data.activity.lstPaXByActivity,
        itineraryLstPaX: this.data.activity.itineraryLstPaX
      });

      Swal.fire({
        position: 'top-end',
        icon: 'info',
        title: 'Actualizando las alergias del pasajero...',
        showConfirmButton: false
      });

      this.fileService
        .mutationUpdatePassengerField({
          passengerId: paxToEdit.passengerId,
          field: 'alergias',
          value: this.newAllergy
        })
        .pipe(
          finalize(() => {
            this.isLoading = false;
          })
        )
        .subscribe({
          next: (dataDetailsFiles: any) => {
            if (dataDetailsFiles?.updatePassengerField) {
              Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'Se editó la alergia del pasajero',
                showConfirmButton: false,
                timer: 4000
              });
              this.data.activity.lstPaXByActivity =
                this.data.activity.lstPaXByActivity.map((pax: any) => {
                  if (pax.passengerId === paxToEdit.passengerId) {
                    return {
                      ...pax,
                      pasajero: {
                        ...pax.pasajero,
                        alergias: this.newAllergy
                      }
                    };
                  }
                  return pax;
                });
              this.ngOnInit();
            } else {
              Swal.fire({
                position: 'top-end',
                icon: 'warning',
                title: 'No se pudo actualizar la nueva alergia',
                showConfirmButton: false,
                timer: 4000
              });
            }
          },
          error: (err) => {
            console.error('Error al actualizar el pasajero:', err);
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: 'Ocurrió un error al actualizar la nueva alergia',
              showConfirmButton: true
            });
          }
        });
    }
  }

  openHistorial(historial: any) {
    this.functionService.openDialogHistorial(historial);
  }

  applyFilterSelect() {
    let dataNew: any = this.data.activity.lstServicios;

    if (this.serviceSelected) {
      dataNew = dataNew?.filter(
        (item: any) => item.nombreServicio === this.serviceSelected
      );
    }

    if (this.providerSelected) {
      dataNew = dataNew?.filter(
        (item: any) => item.objProvider.nombre === this.providerSelected
      );
    }

    if (this.typeServiceSelected) {
      dataNew = dataNew?.filter(
        (item: any) => item.tipoServicio === this.typeServiceSelected
      );
    }

    this.dataServices = dataNew;
  }

  save(): void {
    this.saving = true;
  }

  changeTablaType(value: string) {
    this.tablaType = value;
    this.cdRef.detectChanges(); // Fuerza la detección de cambios para que el paginador se actualice inmediatamente

    this.updatePaginator();
  }

  changeTablaTypeObs(value: string) {
    this.tablaTypeObs = value;
    this.activeTextArea = -1;
    this.cdRef.detectChanges();

    this.updatePaginator();
  }

  updatePaginator() {
    console.log('this.tablaType=', this.tablaType);

    if (this.tablaType === 'file') {
      this.opIncidentTableSource.paginator = this.paginator2;
      this.opIncidentTableSource.sort = this.sort2;
    } else if (this.tablaTypeObs == 'obsService') {
      this.dataServices.paginator = this.paginator2;
      this.dataServices.sort = this.sort2;
    } else if (this.tablaTypeObs == 'obsActivity') {
      this.dataActivity.paginator = this.paginator2;
      this.dataActivity.sort = this.sort2;
    } else {
      this.dataServices.paginator = this.paginator;
      this.dataServices.sort = this.sort;
    }
  }

  setActiveTextArea(i: number, pax: Pax) {
    console.log({
      pax
    });
    if (!pax?.pasajero) {
      Swal.fire({
        position: 'top-end',
        icon: 'warning',
        title: 'No hay pasajero asignado.',
        showConfirmButton: false,
        timer: 4000
      });
      return;
    }
    this.activeTextArea = i;
    if (this.type == BIBLIA_ACTIONS.RESTRICCIONES) {
      this.restricciones = pax.pasajero.restriccionesAlimentarias ?? '';
    } else if (this.type == BIBLIA_ACTIONS.CONDICIONESMEDICAS) {
      this.newCondition = pax.pasajero.condicionesMedicas ?? '';
    } else {
      // @ts-ignore
      this.observaciones = pax?.observaciones ?? '';
    }
  }

  setActiveTextAreaObsSer(i: number, element: any) {
    this.activeTextArea = i;
    if (this.type == BIBLIA_ACTIONS.OBSERVACIONES) {
      this.observaciones = element.observaciones ?? '';
    } else {
      this.observaciones = element?.observaciones ?? '';
    }
  }

  setActiveTextAreaObsAct(i: number, element: any) {
    this.activeTextArea = i;
    if (this.type == BIBLIA_ACTIONS.OBSERVACIONES) {
      this.observaciones = element.obsActivity ?? '';
    } else {
      this.observaciones = element?.obsActivity ?? '';
    }
  }

  setActiveTextAreaTipoDeUnidad(i: number, element: any) {
    console.log(element);
    this.activeTextArea = i;
    if (this.type == BIBLIA_ACTIONS.TIPODEUNIDAD) {
      this.tipoDeUnidad = this.formatTipoDeUnidad(element.tipoDeUnidad);
    } else {
      this.tipoDeUnidad = this.formatTipoDeUnidad(element?.tipoDeUnidad);
    }
    console.log(this.tipoDeUnidad);
  }

  formatTipoDeUnidad(tipoDeUnidad: any): string {
    if (Array.isArray(tipoDeUnidad)) {
      return tipoDeUnidad.filter(Boolean).join(', ');
    }

    return tipoDeUnidad ?? '';
  }

  parseTipoDeUnidadInput(tipoDeUnidad: string): string[] {
    return (tipoDeUnidad || '')
      .split(/\r?\n|,/)
      .map((value) => value.trim())
      .filter(Boolean);
  }
}
